import { useEffect, useState } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink
} from 'react-router-dom'
import { unregister } from '../../serviceWorker'
import { Button, App } from 'antd'

import Account from '../Account/Account'
import Login from '../Login/Login'
import Testing from '../Testing/Testing'

import setGlobalAntd from '../../utils/antd.util'

import './App.scss'

function TApp() {
  const antdApp = App.useApp();
  setGlobalAntd(antdApp)

  const [isAuthenticated, setIsAuthenticated] = useState(() => Boolean(localStorage.getItem('auth_token')))
  const [SwIsRegistered, setSwIsRegistered] = useState(false)

  useEffect(() => {
    navigator.serviceWorker.ready.then(registration => {
      setSwIsRegistered(Boolean(registration))
    })
  }, [])

  useEffect(() => {
    const handleLogout = () => setIsAuthenticated(false)
    window.addEventListener('auth:logout', handleLogout)
    return () => window.removeEventListener('auth:logout', handleLogout)
  }, [])

  if (!isAuthenticated) {
    return (
      <App>
        <Login onLogin={() => setIsAuthenticated(true)} />
      </App>
    )
  }

  const unregisterServiceWorker = () => {
    unregister()?.then(() => {
      setSwIsRegistered(false)
    })
  }

  return (
    <div className="app-container">
      <Router>
        <div className="app-header">
          <div className="nav-links">
            <NavLink className="nav-link" exact to="/">Account</NavLink>
            <NavLink className="nav-link" to="/testing/back-mock">Back mock</NavLink>
            <NavLink className="nav-link" to="/testing/back-real">Back real</NavLink>
            <NavLink className="nav-link" to="/testing/paper">Paper</NavLink>
          </div>
          <div className="header-actions">
            {SwIsRegistered && (
              <Button type="primary" danger onClick={unregisterServiceWorker}>Unregister</Button>
            )}
          </div>
        </div>
        <Switch>
          <Route exact path="/">
            <Account />
          </Route>
          <Route path="/testing/:testType">
            <Testing />
          </Route>
        </Switch>
      </Router>
    </div>
  )
}

export default TApp
